import React from 'react';

import {hooks} from '../hooks';
import {custom} from '../custom';
import {components} from '../components';

export const EditProfile: React.FC = () => {
  const navigate = hooks.useAppNavigate();

  const renderHeader = () => {
    return <components.Header goBack={true} title='ویرایش پروفایل' />;
  };

  const renderContent = () => {
    return (
      <div
        style={{
          paddingLeft: 20,
          paddingRight: 20,
          paddingTop: 40,
          paddingBottom: 20,
        }}
      >
        <custom.InputField
          label='ایمیل'
          containerStyle={{marginBottom: 20}}
          placeholder='Amirhossein Fadaei'
        />
        <custom.InputField
          label='رمز عبور'
          containerStyle={{marginBottom: 20}}
          placeholder='amirhoseyn4083@mail.com'
        />
        <custom.InputField
          label='شماره تلفن'
          containerStyle={{marginBottom: 20}}
          placeholder='09115749390'
        />
        <custom.InputField
          label='آدرس'
          containerStyle={{marginBottom: 20}}
          placeholder='ایران ساری'
        />
        <components.Button
          title='ذخیره تغییرات'
          onClick={() => {
            navigate('/InfoSaved');
          }}
        />
      </div>
    );
  };

  return (
    <>
      {renderHeader()}
      {renderContent()}
    </>
  );
};
